import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TicketFolder } from '@sb-tools/typescript/enums/ticket-folder.enum';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'folderName' })
export class FolderNamePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(folder: TicketFolder): string {
        switch (folder) {
            case TicketFolder.closedByAgent:
                return this.translateService.instant('Closed by agent');
            case TicketFolder.closedByGroup:
                return this.translateService.instant('Closed by group');
            case TicketFolder.answeredByMe:
                return this.translateService.instant('Answered by me');
            case TicketFolder.spam:
                return this.translateService.instant('Spam');
            case TicketFolder.expired:
                return this.translateService.instant('Expired');
            case TicketFolder.sharedAccess:
                return this.translateService.instant('Assigned');
            case TicketFolder.reminders:
                return this.translateService.instant('Reminders');
            default:
                return this.translateService.instant('Unknown folder');
        }
    }
}
